module.exports = __webpack_public_path__ + "static/media/trash-light.8c9a0e2b.svg";